/* Mr. Watt · Collectiepagina (v2) · kleurkiezer in de kop
   Hover, focus of tik op een bolletje: het beeld in de kop toont die kleur
   (productfoto of nachtbeeld, volgens de instelling) en het label toont de kleurnaam.
   Een klik opent het product. */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-mw-ready')) return;
    root.setAttribute('data-mw-ready', '1');
    var swatches = root.querySelectorAll('.mw-col__swatch');
    var img = root.querySelector('.mw-col__visual img');
    var label = root.querySelector('[data-mw-name]');
    if (!swatches.length) return;
    function select(btn) {
      swatches.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      if (label) label.textContent = btn.getAttribute('data-name') || '';
      var src = btn.getAttribute('data-src');
      if (!img || !src || img.getAttribute('src') === src) return;
      img.classList.add('is-fading');
      var pre = new Image();
      pre.onload = function () {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        if (btn.getAttribute('data-alt')) img.alt = btn.getAttribute('data-alt');
        requestAnimationFrame(function () { img.classList.remove('is-fading'); });
      };
      pre.src = src;
    }
    swatches.forEach(function (b) {
      b.addEventListener('mouseenter', function () { select(b); });
      b.addEventListener('focus', function () { select(b); });
      b.addEventListener('touchstart', function () { select(b); }, { passive: true });
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('.mw-col').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
